module.exports = __webpack_public_path__ + "static/media/banaye.59304886.ogg";